import api from '@/apis/di/budgetKindItemAPI.js';
import { usefilterActionCombo } from './filterActionCombo.js';
import { getCurrentInstance } from 'vue';

// Combo grid Khoản
export const useBudgetSubKindItemActiveComboGrid = (comboboxDataRemote, comboboxLoadData) => {
  const { proxy } = getCurrentInstance();
  const { extendFilter } = usefilterActionCombo();

  // func call api lấy dữ liệu combo
  const onBudgetSubKindItemActiveComboboxLoadData = (payload, row, column, custom) => {
    let ors = [{ Field: 'inactive', Operator: 'NULL' }];

    let isHaveBudgetPermission = proxy.$store.state.context.Context.IsBudgetPermission;
    let extend = [
      { Field: 'inactive', Value: false, Ors: ors },
      { Field: 'grade', Value: 1, Operator: '>' },
    ]; // 2 Là khoản
    // Nếu phân quyền nguồn khoản thì sẽ đẩy thêm điều kiện is_parent = null
    if(isHaveBudgetPermission){
      extend.push({ Field: 'is_parent', Operator: 'NULL', Ors: [{ Field: 'is_parent', Value: false}] });
    }
    payload.sort = 'budget_kind_item_code';
    payload.columns += ',misa_code_id';
    payload.filter = extendFilter(payload.filter, extend);

    comboboxLoadData(payload, api, comboboxDataRemote, column.dataField, custom?.callBackFn);
  };

  // config columns combo
  const budgetSubKindItemActiveComboConfig = {
    data: comboboxDataRemote,
    columns: [
      {
        title: 'Mã khoản',
        dataField: 'budget_kind_item_code',
        width: 100,
        filterOperator: proxy.$ms.constant.FilterOperator.StartsWith,
      },
      {
        title: 'Tên khoản',
        dataField: 'budget_kind_item_name',
        filterOperator: proxy.$ms.constant.FilterOperator.Contains,
        width: 500,
      },
    ],
    displayField: 'budget_kind_item_code',
    valueField: 'budget_kind_item_code',
    queryMode: 'remote',
    dropdownWidth: 600,
    comboboxLoadData: onBudgetSubKindItemActiveComboboxLoadData,
    modelValueField: 'budget_sub_kind_item_code',
  };

  // Sự kiện load combo trên grid
  return {
    budgetSubKindItemActiveComboConfig,
    onBudgetSubKindItemActiveComboboxLoadData, // trả về thêm để dùng chung chả cả combo ko thuộc grid
  };
};
